export const USE_PAGINATION_API = true
export const PAGE_IMAGE = "/images/headers/khub_blog.png"
export const SORT_OPTIONS = ['date'/* , 'title' */]
export const STATE_KEY = 'organizationBlogs'
